export const getProjects = (search) =>
  fetch(`/projects.json?view=minimal&search=${search}`)
    .then(response => response.json());
